import type React from 'react';
import checked from '../../../shared/icons/images/radio-checked.svg?url';
import unchecked from '../../../shared/icons/images/radio-unchecked.svg?url';
import bankIdLogo from './icons/bankid_logo.svg?url';
import vippsLogo from './icons/vipps_logo.svg?url';

import './verification-provider-selection.scss';

const providerConfig = [
  {
    key: 'Vipps',
    displayName: 'Vipps',
    imgSrc: vippsLogo,
    imgWidth: 38,
    imgHeight: 24,
  },
  {
    key: 'BankID',
    displayName: 'BankID',
    imgSrc: bankIdLogo,
    imgWidth: 40,
    imgHeight: 30,
  },
] as const;

export const PROVIDER_SELECTION_HEADING_ID = 'verification-provider-selection-heading';
export const PROVIDER_SELECTION_ERROR_ID = 'verification-provider-selection-error';

export const VerificationProviderSelection: React.FC<{
  selectedProvider: string;
  handleProviderChange: React.ChangeEventHandler<HTMLInputElement>;
  hasError?: boolean;
}> = ({ selectedProvider, handleProviderChange, hasError = false }) => {
  return (
    // The fieldset groups the radios; it borrows its accessible name from the
    // step heading so screen readers announce the group when focus enters it.
    <fieldset className="verification-provider-selection" aria-labelledby={PROVIDER_SELECTION_HEADING_ID}>
      {providerConfig.map((provider) => {
        const isChecked = selectedProvider === provider.key;
        return (
          <label className="radio-verification-button" key={provider.key}>
            <input
              type="radio"
              value={provider.key}
              name="verificationProvider"
              onChange={handleProviderChange}
              checked={isChecked}
              aria-invalid={hasError || undefined}
              aria-describedby={hasError ? PROVIDER_SELECTION_ERROR_ID : undefined}
            />
            <img className="radio-icon" src={isChecked ? checked : unchecked} alt="" width={24} height={24} />
            <span className="display-text">{provider.displayName}</span>
            <img className="provider-logo" src={provider.imgSrc} alt="" width={provider.imgWidth} height={provider.imgHeight} />
          </label>
        );
      })}
    </fieldset>
  );
};
